import { environment } from "../../../environments/environment";
export class Config {

    protected readonly BASE_URL_API = "https://joytogive.worldvision.org.ph/api/";
    protected readonly BASE_URL_API_PUBLIC = "https://joytogive.worldvision.org.ph/api/public/";
    protected readonly BASE_URL_API_WEBSITE = "https://joytogive.worldvision.org.ph/api/website/";

    // protected readonly BASE_URL_API = "http://e4a472df.ngrok.io/joytogive/backend/public/api/";
    // protected readonly BASE_URL_API_WEBSITE = "http://e4a472df.ngrok.io/joytogive/backend/public/api/website/";

    //http://e4a472df.ngrok.io
    
    constructor(){
        
    }
}